export * from './resize-observer';

export { default as domService } from './dom.service';
